import { render, staticRenderFns } from "./PostingModalWithButton.vue?vue&type=template&id=35e026a1"
import script from "./PostingModalWithButton.vue?vue&type=script&lang=ts"
export * from "./PostingModalWithButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e026a1')) {
      api.createRecord('35e026a1', component.options)
    } else {
      api.reload('35e026a1', component.options)
    }
    module.hot.accept("./PostingModalWithButton.vue?vue&type=template&id=35e026a1", function () {
      api.rerender('35e026a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/postings/PostingModalWithButton.vue"
export default component.exports